import { ReactNode } from 'react';

import {
  fallbackErrorHeader,
  fallbackErrorMessage,
  isDefined,
  lenderDisplayNameMap,
  LenderDisplayNameT,
  LoanStatusT,
  noBalanceDueHeader,
  noBalanceDueMessage,
  noValidPaymentMethodsHeader,
  noValidPaymentMethodsMessageHelper,
} from '@consumer-frontend/nc-utils';

import { uiRoutes } from '../lib';

export const noValidPaymentMethodsMessage = noValidPaymentMethodsMessageHelper(uiRoutes.legacyAH.managePaymentMethods);

export type UseMakeAPaymentBlockerT = {
  hasValidPaymentMethod: boolean;
  isLoading: boolean;
  balance?: number;
  currentOwner?: LenderDisplayNameT;
  loanStatus?: LoanStatusT;
};

export const useMakeAPaymentBlocker = ({
  balance,
  currentOwner,
  hasValidPaymentMethod,
  loanStatus,
  isLoading,
}: UseMakeAPaymentBlockerT) => {
  const hasRequired = isDefined(loanStatus) && isDefined(balance);

  if (isLoading || !hasRequired) {
    return {
      errorType: '',
      header: '',
      message: '',
      shouldBlock: false,
    };
  }

  const isPartnerOrNetCredit = Object.values(lenderDisplayNameMap).includes(currentOwner as LenderDisplayNameT);
  const hasValidLoanStatus = [
    'current',
    'past_due',
    'called_due',
  ].includes(loanStatus);

  let header: ReactNode = fallbackErrorHeader;
  let message: ReactNode = fallbackErrorMessage;

  // eslint-disable-next-line no-nested-ternary
  let errorType = isPartnerOrNetCredit
    ? hasValidLoanStatus
      ? 'unknown'
      : 'invalid_loan_status'
    : 'invalid_loan_owner'
  ;

  if (!hasValidPaymentMethod) {
    header = noValidPaymentMethodsHeader;
    message = noValidPaymentMethodsMessage;
    errorType = 'no_valid_payment_method';
  } else if (!balance) {
    header = noBalanceDueHeader;
    message = noBalanceDueMessage;
    errorType = 'no_balance_due';
  }

  return {
    errorType,
    header,
    message,
    shouldBlock: !(
      hasValidLoanStatus
      && balance > 0
      && isPartnerOrNetCredit
      && hasValidPaymentMethod
    ),
  };
};
